import { render, staticRenderFns } from "./paper-result-report-new-h5.vue?vue&type=template&id=248415a1&scoped=true"
import script from "./paper-result-report-new-h5.vue?vue&type=script&lang=ts"
export * from "./paper-result-report-new-h5.vue?vue&type=script&lang=ts"
import style0 from "./paper-result-report-new-h5.vue?vue&type=style&index=0&id=248415a1&prod&scoped=true&lang=scss"
import style1 from "./paper-result-report-new-h5.vue?vue&type=style&index=1&id=248415a1&prod&scoped=true&lang=scss"
import style2 from "./paper-result-report-new-h5.vue?vue&type=style&index=2&id=248415a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248415a1",
  null
  
)

export default component.exports